import { Link, useLocation } from "react-router-dom";
import { Radar } from "lucide-react";
import { useArcaOSAccess } from "./useArcaOSAccess";

// The primary, unmistakable entry point into ArcaOS / Mission Control.
// Only shown to authenticated users who have ArcaOS access, and hidden when the
// user is already inside /os. `variant` tunes the styling for different headers.
export default function MissionControlButton({ variant = "solid", className = "" }) {
  const { hasAccess } = useArcaOSAccess();
  const location = useLocation();
  if (!hasAccess || location.pathname.startsWith("/os")) return null;

  const base = "inline-flex items-center gap-2 rounded-full font-medium text-sm whitespace-nowrap transition-all duration-300";
  const styles = variant === "ghost"
    ? "font-mono text-xs uppercase tracking-[0.15em] text-[#00F0FF] hover:text-white px-2 py-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00F0FF] focus-visible:ring-offset-2 focus-visible:ring-offset-black rounded-full"
    : "bg-gradient-to-r from-[#0055FF] to-[#0077FF] text-white px-4 py-2.5 shadow-[0_0_25px_rgba(0,85,255,0.45)] hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00F0FF] focus-visible:ring-offset-2 focus-visible:ring-offset-black";

  return (
    <Link to="/os" className={`${base} ${styles} ${className}`} data-testid="mission-control-entry">
      <Radar size={variant === "ghost" ? 14 : 16} />
      Mission Control
    </Link>
  );
}
